import { render } from "./AppDynamicForm.vue?vue&type=template&id=0b1a5a10"
import script from "./AppDynamicForm.vue?vue&type=script&lang=js"
export * from "./AppDynamicForm.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ferlando/Desktop/Baboon/baboon-pos/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__